import { useEffect, useState } from 'preact/hooks';
import { Hemicycle } from '../components/Hemicycle.tsx';
import { Result, Tally } from '../components/Tally.tsx';
import { Connection, ErrorBox, Pill } from '../components/ui.tsx';
import { api, ApiError } from '../lib/api.ts';
import { votingPill } from '../lib/labels.ts';
import { useEventScreen } from '../lib/useEventScreen.ts';

/** Pantalla pública para proyectar: requiere una sesión de staff (p. ej. rol observador). */
export function Pantalla({ eventId }: { eventId: string }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    api('GET', '/api/auth/me').then(() => setReady(true)).catch((e) => {
      if (e instanceof ApiError && e.status === 401) location.replace('/acceso');
    });
  }, []);
  return ready ? <Screen eventId={eventId} /> : <div class="app"><p class="hint">Cargando…</p></div>;
}

function Screen({ eventId }: { eventId: string }) {
  const { detail, state, connection, error } = useEventScreen(eventId);
  if (!detail || !state) return <div class="app"><ErrorBox error={error} /></div>;
  const voting = state.voting;
  const pill = votingPill(voting);
  return (
    <div class="app screen">
      <header class="top">
        <div><h2>{detail.event.title}</h2><p class="matter">{voting ? voting.matter.title : 'Sin votación abierta'}</p></div>
        <div class="row"><Pill kind={pill.kind}>{pill.text}</Pill><Connection state={connection} /></div>
      </header>
      <ErrorBox error={error} />
      <div class="screen-grid">
        <section class="panel"><Hemicycle seats={state.seats} votes={state.votes} voting={voting} present={state.quorum.present} /></section>
        <section class="panel">
          <div class="row">
            <Pill kind={state.quorum.ok ? 'ok' : 'bad'}>{state.quorum.ok ? 'Hay quórum' : 'Sin quórum'}</Pill>
            <span class="num">{state.quorum.present} presentes de {state.quorum.total}; mínimo {state.quorum.need}</span>
          </div>
          {voting && <p class="hint">{voting.mode === 'secreta' ? 'Votación secreta' : 'Votación nominal'} · reglas {voting.rulesVersion}{voting.round > 1 ? ` · ronda ${voting.round}` : ''}</p>}
          <Tally voting={voting} present={state.quorum.present} />
          {voting?.state === 'closed' && <Result voting={voting} />}
        </section>
      </div>
    </div>
  );
}
